/**
 * Display-only honorific formatting (Mr → Mr.) — does not change stored values.
 */
export function formatHonorificTitle(title: string | null | undefined): string {
  const trimmed = (title ?? '').trim();
  if (!trimmed) return '';
  return trimmed.endsWith('.') ? `${trimmed} ` : `${trimmed}. `;
}

export function formatFullNameWithTitle(
  title: string | null | undefined,
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string {
  const name = `${firstName ?? ''} ${lastName ?? ''}`.trim() || 'Guest';
  return `${formatHonorificTitle(title)}${name}`.trim();
}

export function formatGuestEventDisplayName(
  guest: {
    guest_name?: string | null;
    guest?: {
      title?: string | null;
      first_name?: string | null;
      last_name?: string | null;
    } | null;
  },
  displayNameFromHook?: string | null,
): string {
  const titlePrefix = formatHonorificTitle(guest.guest?.title);
  const baseName =
    guest.guest_name ||
    displayNameFromHook ||
    `${guest.guest?.first_name || 'Unknown'} ${guest.guest?.last_name || 'Guest'}`;
  return `${titlePrefix}${baseName}`.trim();
}
